import React from 'react';
import { BundleDetailTemplate } from './BundleDetailTemplate';

export const BundleOperations = () => <BundleDetailTemplate slug="hr-operations" />;
